import React from "react"
import { StyledPrincipal } from "../styles/components"
import { ImageExperiencia } from "./"

export default function Experiencia() {
  return (
    <StyledPrincipal>
      <div>
        <h2>SANDRA RAIRAN</h2>
        <small>Soy una Ingeniera con habilidades en el aprendizaje automático y  en la Ciencia de Datos. Busco colaborar en una posición Data Scientist ,ya que reciente he realizado proyectos 
        en R y Python. En mi cuenta de GitHub o Linkedin se encuentran los repositorios.
        
</small>
      </div>
      <ImageExperiencia name="icon" />
    </StyledPrincipal>
  )
}